import {
  ChangeDetectorRef,
  Directive,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthStore } from '@store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appHideForNoDashboardFeature]',
})
export class HideForNoDashboardFeatureDirective implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private authStore: AuthStore,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.authStore.selectDashboardFeatureIfAvailable$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((isDashboardFeatureAvailable) => {
        this.updateView(isDashboardFeatureAvailable);
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private updateView(isDashboardFeatureAvailable: boolean): void {
    this.viewContainer.clear();
    if (isDashboardFeatureAvailable) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
    this.cdr.detectChanges();
  }
}
